import { render, staticRenderFns } from "./EditTextBlockModal.vue?vue&type=template&id=24d95091&lang=pug&"
import script from "./EditTextBlockModal.vue?vue&type=script&lang=js&"
export * from "./EditTextBlockModal.vue?vue&type=script&lang=js&"
import style0 from "./EditTextBlockModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports